import React from "react";
import { Card, PopoutWrapper, Spinner, Title } from "@vkontakte/vkui";


class LoadSpinner extends React.Component {
  render() {
    return <PopoutWrapper>
      <Card size="l" mode="shadow">
        <Spinner size="large" />
        <Title level="1" weight="3">Соединение с сервером...</Title>
      </Card>
    </PopoutWrapper>
  };
}

export default LoadSpinner;
